import { render, staticRenderFns } from "./LottoMarketTitleModal.vue?vue&type=template&id=f2da539c&scoped=true&"
import script from "./LottoMarketTitleModal.vue?vue&type=script&lang=js&"
export * from "./LottoMarketTitleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2da539c",
  null
  
)

export default component.exports